import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { isMobileOnly } from "react-device-detect";
import Section from "./goups";
import ProductsRow from "./products_row";
import ProductsRowList from "./products_row_list";
import { usePosFilter } from "../../../hooks/usePosFilter";
import useSettings from "../../../hooks/settings";

const Products = ({ addFunction, menu_all, tiggerAdded, onDelivery, onMakeOrder }) => {
  const [settings] = useSettings();
  const useListView = isMobileOnly && settings.pos_list_view;
  const [productsbyCat, setProductsbyCat] = useState(null);
  const [selectedCat, setSelectedCat] = useState(null);
  const visibleProductsRef = useRef([]);

  const handleSelect = useCallback((overrideIdx) => {
    const idx = overrideIdx != null ? overrideIdx : selectedIndexRef.current;
    const visible = visibleProductsRef.current;
    if (idx < 0 || idx >= visible.length) return;
    const product = visible[idx];
    if (product.snoozed) return;
    // Simulate the click event that addFunction expects
    // Dataset values are always strings, so coerce to match
    addFunction({
      currentTarget: { dataset: { product_id: String(product.id) } },
    });
  }, [addFunction]);

  const { filter, clearFilter, selectedIndex, setVisibleCount } = usePosFilter({
    onSelect: handleSelect,
    onDelivery,
    onMakeOrder,
  });

  // Keep a ref so the callback doesn't go stale
  const selectedIndexRef = useRef(selectedIndex);
  selectedIndexRef.current = selectedIndex;

  useEffect(() => {
    if (menu_all) {
      arrangeByCat(menu_all);
    }
  }, [menu_all]);

  const arrangeByCat = (menu_all) => {
    const set_productsbyCat = {};
    Object.keys(menu_all.categories).map((key) => {
      const cat_id = menu_all.categories[key].id;
      let loopProducts = { ...menu_all.products };

      Object.keys(loopProducts).map((key) => {
        if (loopProducts[key].category.id !== cat_id) delete loopProducts[key];
        return true;
      });

      return (set_productsbyCat[key] = loopProducts);
    });
    setProductsbyCat({ ...set_productsbyCat });
  };

  // Build flat list of visible products and the selected product ID
  const { visibleProducts, selectedProductId } = useMemo(() => {
    if (!productsbyCat) return { visibleProducts: [], selectedProductId: null };

    const normalizedFilter = filter.toLowerCase().trim();
    const flat = [];

    Object.keys(productsbyCat).forEach((catId) => {
      const category = menu_all.categories[catId];
      // eslint-disable-next-line
      const hiddenByCat = selectedCat ? selectedCat != category.id : false;
      if (hiddenByCat) return;

      Object.keys(productsbyCat[catId]).forEach((key) => {
        const product = productsbyCat[catId][key];
        const title = (product.title || "").toLowerCase();
        if (!normalizedFilter || title.includes(normalizedFilter)) {
          flat.push(product);
        }
      });
    });

    const selId =
      selectedIndex >= 0 && selectedIndex < flat.length
        ? flat[selectedIndex].id
        : null;

    return { visibleProducts: flat, selectedProductId: selId };
  }, [productsbyCat, filter, selectedCat, selectedIndex, menu_all]);

  // Sync visible count + ref
  useEffect(() => {
    visibleProductsRef.current = visibleProducts;
    setVisibleCount(visibleProducts.length);
  }, [visibleProducts, setVisibleCount]);

  const products = (selectedCat) => {
    const normalizedFilter = filter.toLowerCase().trim();
    const RowComponent = useListView ? ProductsRowList : ProductsRow;
    let productsrow = Object.keys(productsbyCat).map((catId) => {
      let loopProducts = { ...productsbyCat[catId] };

      // Filter products by typed text
      if (normalizedFilter) {
        const filtered = {};
        Object.keys(loopProducts).forEach((key) => {
          const title = (loopProducts[key].title || "").toLowerCase();
          if (title.includes(normalizedFilter)) {
            filtered[key] = loopProducts[key];
          }
        });
        loopProducts = filtered;
      }

      const category = menu_all.categories[catId];
      return (
        <RowComponent
          key={catId}
          addFunction={addFunction}
          tiggerAdded={tiggerAdded}
          // eslint-disable-next-line
          selectedCat={selectedCat ? selectedCat == category.id : null}
          title={category.name}
          products={loopProducts}
          selectedProductId={selectedProductId}
        />
      );
    });
    return productsrow;
  };

  const catHandler = (ev) => {
    const catId = +ev.currentTarget.dataset.cat_id;
    const prev_cat = selectedCat;
    if (prev_cat === catId) {
      setSelectedCat(null);
    } else {
      if (isMobileOnly) {
        const products_cont = document.getElementById("products_container");
        products_cont.scrollIntoView({ behavior: "smooth" });
      }
      setSelectedCat(catId);
    }
  };

  return (
    <div className="pos_panel min_vh_7 ">
      {/* <Section items={group_list} title="Grupos" /> */}
      {menu_all ? (
        <Section
          items={menu_all.categories}
          selectedCat={selectedCat}
          title="Tipos"
          click={catHandler}
        />
      ) : null}
      <hr />
      {filter && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 12px",
            marginBottom: "8px",
            background: "#FFBB28",
            borderRadius: "6px",
            fontSize: "14px",
          }}
        >
          <i className="fas fa-search" />
          <span>
            <strong>{filter}</strong>
          </span>
          <span style={{ marginLeft: "8px", color: "#666", fontSize: "12px" }}>
            ↑↓/Tab: navegar &middot; Enter: seleccionar &middot; Esc: limpiar
          </span>
          <button
            onClick={clearFilter}
            style={{
              marginLeft: "auto",
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              padding: "0 4px",
            }}
          >
            &times;
          </button>
        </div>
      )}
      <div id="products_container">
        {productsbyCat ? products(selectedCat) : null}
        {filter && visibleProducts.length === 0 && (
          <div
            style={{
              textAlign: "center",
              padding: "3rem 1rem",
              color: "#999",
            }}
          >
            <i
              className="fas fa-search"
              style={{ fontSize: "48px", marginBottom: "16px", display: "block" }}
            />
            <h4 style={{ color: "#666", fontWeight: 600 }}>Sin Productos</h4>
            <p style={{ fontSize: "14px" }}>
              No se encontraron productos para "<strong>{filter}</strong>"
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;
